<script lang="ts" setup>
import {useThemeSetup} from '@/ts/composables/stateful/use-theme';

useThemeSetup();
</script>

<template>
  <div class="page-container">
    <router-view/>
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  display: flex;
  max-width: 100%;
  height: 100%;
}
</style>
